<template>
  <div>
    <form @submit.prevent="createPromo">
      <modal v-show="isModalVisible" @close="closeModal" modalIsLarge footer>
        <template v-slot:title>
          <h5>Create AD</h5>
        </template>
        <template v-slot:body>
          <div class=" form-group">
            <label for="icon_file">Image File</label>
            <img
              v-if="base_six !== ''"
              :src="base_six"
              alt=""
              class=" card--profile-image avatar d-block"
            />
            <img
              v-else-if="formObj.image !== null && formObj.image !== ''"
              :src="formObj.image"
              alt=""
              class=" card--profile-image avatar d-block"
            />
            <button
              class=" btn btn-secondary d-block mt-1"
              @click="onPickButton"
              type="button"
            >
              Upload Bank Image
            </button>
            <input
              type="file"
              class="upload"
              ref="fileChange"
              accept="*"
              style="display:none;"
              @change="onFilePickedButton"
            />
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="name">Name</label>
                <input
                  type="text"
                  v-model="formObj.name"
                  class="form-control"
                  placeholder="Ad's Name"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="daily_limit">Description</label>
                <textarea
                  type="text"
                  v-model="formObj.description"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="promo_category">Promo Type</label>
                <select
                  name=""
                  v-model="formObj.type"
                  id=""
                  class="form-control"
                >
                  <option value="" disabled selected
                    >Pleease Select Type</option
                  >
                  <option value="popup">Popup</option>
                  <option value="banner">Banner</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class=" form-group">
                <label for="start_date">Start Date</label>
                <input
                  type="date"
                  v-model="formObj.start_date"
                  class="form-control"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class=" form-group">
                <label for="end_date">Stop Date</label>
                <input
                  type="date"
                  v-model="formObj.stop_date"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Status</label>
                <select
                  name=""
                  id=""
                  class="form-control"
                  v-model="formObj.status"
                >
                  <option value="" disabled selected
                    >Please Select Status</option
                  >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            class="btn btn-primary"
            @submit.prevent="createUpdatePromo"
            :disabled="loading"
          >
            <span class="custom-loader" v-if="loading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">
                Updating ...
              </span>
            </span>
            <span v-else>
              Create Ads
            </span>
          </button>
          <button @click.prevent="closeModal" class="btn btn-secondary">
            Close
          </button>
        </template>
      </modal>
    </form>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Ads ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h3 class=" mb-2 font-regular">Ads</h3>
        </div>
        <div class="col-auto">
          <button
            class="button button--outline text-uppercase"
            @click="openModal"
          >
            Create AD
          </button>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="arr"
              :fields="fields"
              pagination
              sorter
              tableFilter
            >
              <template #image="{item}">
                <td>
                  <img
                    :src="item.image_url"
                    alt="logo"
                    style="height: 50px; width: 50px;"
                  />
                </td>
              </template>
              <template #start_date="{item}">
                <td class="table--action-mobile">
                  {{ item.start_date | date }}
                </td>
              </template>
              <template #stop_date="{item}">
                <td class="table--action-mobile">
                  {{ item.stop_date | date }}
                </td>
              </template>
              <template #actions="{item}">
                <td class="table--action-mobile d-flex border-0">
                  <button
                    class="btn btn-secondary me-2"
                    @click="showUpdatemodal(item)"
                  >
                    Edit
                  </button>
                  <router-link
                    class="button"
                    :to="{ name: 'Promo', params: { slug: item.id } }"
                  >
                    View</router-link
                  >
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";

const fields = [
  "image",
  "name",
  "type",
  "status",
  "start_date",
  "stop_date",
  "actions"
];

export default {
  name: "PromosPage",
  components: {
    CDataTable
  },
  computed: {
    formIsNotValid() {
      for (let key in this.formObj) {
        if (this.formObj.hasOwnProperty(key) && this.formObj[key] === "") {
          return true;
        }
      }
      return false;
    }
  },
  data() {
    return {
      fields,
      isModalVisible: false,
      pageLoading: true,
      loading: false,
      arr: [],
      formObj: {
        name: "",
        type: "",
        category: "",
        start_date: "",
        stop_date: "",
        status: ""
      },
      base_six: null
    };
  },
  methods: {
    isNumber: function(evt) {
      console.log(evt.key);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    async createPromo() {
      this.loading = true;
      console.log(this.formObj);
      let formData = new FormData();
        formData.append("name", this.formObj.name);
        formData.append("type", this.formObj.type);
        formData.append("description", this.formObj.description);
        formData.append("start_date", this.formObj.start_date);
        formData.append("stop_date", this.formObj.stop_date);
        formData.append("status", this.formObj.status);
        if(this.formObj.image !== null){
          formData.append("image", this.formObj.image);
        }
        if(this.formObj.id){
          formData.append("id", this.formObj.id);
        }
        const headers = { "Content-Type": "multipart/form-data" };


      try {
        const res = await ApiService.post("ads/create_and_update", formData, {
          headers
        });

        this.closeModal();
        this.loading = false;
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        this.getAds();
      } catch (error) {
        this.closeModal();
        console.log(error);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        this.loading = false;
      }
    },

    async getAds() {
      try {
        const res = await ApiService.get("ads");

        this.arr = res.data.data.data;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error);
      }
    },
    async showUpdatemodal(item) {
      this.formObj = Object.assign({}, item);
      this.openModal();
    },
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onPickButton() {
      this.$refs.fileChange.click();
    },
    onFilePickedButton(event) {
      const files = event.target.files;
      let filename = files[0].name;
      this.imageFileType = files[0].type.match(/.(jpg|jpeg|png)$/i);
      if (filename.lastIndexOf(".") <= 0) {
        return alert("please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        // this.service.image = fileReader.result;
        this.base_six = fileReader.result;
        // console.log(this.service.image);
        // console.log(this.service);
      });
      fileReader.readAsDataURL(files[0]);
      this.formObj.image = files[0];
    }
  },
  mounted() {
    this.getAds();
  }
};
</script>

<style scoped></style>
